<template>
  <div>
    <v-col>
      <h1 class="container3 mt-16">
        No area created yet
      </h1>
      <div class="container3 mt-4">
        <img
          src="./../../../../../assets/area-image.png"
          height="200px"
          width="200px"
        >
      </div>
      <h1 class="text-subtitle-1 text-center font-weight-medium mt-8">
        Select the drawing tool and define a custom area
      </h1>
    </v-col>
  </div>
</template>

<script>
export default {
  name: "EmptyAreaComponent",
};
</script>

  <style scoped>
.container3 {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
